/**
 * I tought it'd be great if we use report ID in state for the report identifier
 * instead of report name, as report names might be too long,
 * but I guess using the name (eg: 'accountsReceivable' instead of '3') is more verbose
 * and would be easier to maintain in the future. - Luqman
 */
function accountsReceivableStates() {
    return {
        filter: {
            asOf: null,
            totalDue: "0",
            exemptFlag: "1"
        },
        selectedClientIds: []
    };
}

function rabiesSummaryStates() {
    return {
        selectedRecordIds: [],
        species_option: [],
        city_option: []
    };
}

function timesheetsStates() {
    return {
        isIncludedInactive: false
    };
}

const state = {
    accountsReceivable: accountsReceivableStates(),
    rabiesSummary: rabiesSummaryStates(),
    timesheets: timesheetsStates()
};

const getters = {};

const actions = {};

const mutations = {
    resetAccountReceivable(state) {
        state.accountsReceivable = accountsReceivableStates();
    },
    accountsReceivableFilter(state, payload) {
        state.accountsReceivable.filter[payload.key] = payload.value;
    },
    accountsReceivableRegisterClientIds(state, value) {
        state.accountsReceivable.selectedClientIds = value;
    },
    rabiesSummaryRecordIds(state, value) {
        state.rabiesSummary.selectedRecordIds = value;
    },
    rabiesSummarySpeciesOption(state, value) {
        state.rabiesSummary.selectedRecordIds = value;
    },
    rabiesSummaryCityOption(state, value) {
        state.rabiesSummary.selectedRecordIds = value;
    },
    setTimesheetsIsIncludedInactive(state, payload) {
        state.timesheets.isIncludedInactive = payload;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
